import React from "react";
import Helmet from "react-helmet";
import {Link} from "react-router-dom";
function Header(){
    return (
        <div>
             <header className="main-header style-one">
        <div className="header-top">
          <div className="top-inner clearfix">
            <ul className="info-list pull-left clearfix">
              <li>
                <i className="flaticon-email" />
                <Link to="#">enku@gamil.com</Link>
              </li>
              <li>
                <i className="flaticon-telephone" />
                <Link to="#">09111213145</Link>
              </li>
              <li>
                <i className="flaticon-pin" />
               bole around megablock
              </li>
            </ul>
            <div className="right-column pull-right clearfix">
              <ul className="social-links clearfix">
                <li>
                  <Link to="/">
                    <i className="fab fa-facebook-square" />
                  </Link>
                </li>
                <li>
                  <Link to="/">
                    <i className="fab fa-twitter" />
                  </Link>
                </li>
                <li>
                  <Link to="/">
                    <i className="fab fa-pinterest-p" />
                  </Link>
                </li>
                <li>
                  <Link to="/">
                    <i className="fab fa-instagram" />
                  </Link>
                </li>
              </ul>
          
            </div>
          </div>
        </div>
        <div className="header-lower">
          <div className="outer-box">
            <div className="logo-box">
            
            </div>
            <div className="menu-area">
              <div className="mobile-nav-toggler">
                <i className="icon-bar" />
                <i className="icon-bar" />
                <i className="icon-bar" />
              </div>
              <nav className="main-menu navbar-expand-md navbar-light">
                <div
                  className="collapse navbar-collapse show clearfix"
                  id="navbarSupportedContent"
                >
                  <ul className="navigation clearfix">
                    <li className="current dropdown">
                      <a >Gemstone</a>
                      <ul>
                        
                        <li>
                          <Link to="/gemdetail/1">Emerlad</Link>
                        </li>
                        <li>
                          <Link to="/gemdetail/2">Opel</Link>
                        </li>
                        <li>
                          <Link to="/gemdetail/3">Ruby</Link>
                        </li>
                        <li>
                          <Link to="/gemdetail/4">Sapphire</Link>
                        </li>
                        <li>
                          <Link to="/gemdetail/5">Dimond</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Genuinty</Link>
                      <ul>
                      
                        <li>
                          <Link to ="/genuinity">How to check genuinty</Link>
                        </li>
                       
                       
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Gems In Ethiopia</Link>
                      <ul>
                      <li>
                          <Link to="/history/5">History of gem in ethiopia</Link>
                        </li>
                       
                        <li>
                          <Link to="/market">Gem in ethiopia market</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Classfiction</Link>
                      <ul>
                        <li>
                          <Link to="/classfication/2"> Precious vs Semi-precious</Link>
                        </li>
                        <li>
                        <Link to="/classfication/1"> Naturial vs Synthetic</Link>
                        </li>
                        <li>
                        <Link to="/classfication/3">Treated vs Untreated</Link>
                        </li>
                      </ul>
                    </li>
                    <li className="dropdown">
                     <Link to="/about">
                     About Us
                     </Link>
                    </li>
                    <li>
                    <Link to="/contact">
                     Contact Us
                     </Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div className="menu-right-content clearfix">
              <div className="search-box-outer">
                <div className="dropdown">
                 
                  <div
                    className="dropdown-menu search-panel"
                    aria-labelledby="dropdownMenu3"
                  >
                    
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
        <div className="sticky-header">
          <div className="outer-box">
            <div className="logo-box">
              <figure className="logo">
               <Link to="/">
               <img  style ={{ height:"65px",width:"105px" }} src="/assets/images/icons/logo.png" alt />
               </Link>
                 
                
              </figure>
            </div>
            <div className="menu-area">
              <nav className="main-menu clearfix"></nav>
            </div>
            <div className="menu-right-content clearfix">
              <div className="search-box-outer">
                <div className="dropdown">
                  {/* <button
                    className="search-box-btn"
                    type="button"
                    id="dropdownMenu4"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="flaticon-magnifying-glass" />
                  </button> */}
                  <div
                    className="dropdown-menu search-panel"
                    aria-labelledby="dropdownMenu3"
                  >
                    {/* <div className="form-container">
                      <form method="post" action="blog.html">
                        <div className="form-group">
                          <input
                            type="search"
                            name="search-field"
                            defaultValue
                            placeholder="Search...."
                            required
                          />
                          <button type="submit" className="search-btn">
                            <span className="fas fa-search" />
                          </button>
                        </div>
                      </form>
                    </div> */}
                  </div>
                </div>
              </div>
              {/* <div className="btn-box">
                <a href="contact.html" className="theme-btn-one">
                  Book appointment
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </header>
        <div className="mobile-menu">
    <div className="menu-backdrop" />
    <div className="close-btn"><i className="fas fa-times" /></div>
    <nav className="menu-box">
      <div className="nav-logo"><Link to="index.html"><img src="assets/images/logo-2.png" alt title /></Link></div>
      <div className="menu-outer">{/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}</div>
      <div className="contact-info">
        <h4>Contact Info</h4>
        <ul>
          <li>Chicago 12, Melborne City, USA</li>
          <li><Link to="#">+88 01682648101</Link></li>
          <li><Link to="#">info@example.com</Link></li>
        </ul>
      </div>
      <div className="social-links">
        <ul className="clearfix">
          <li><Link to="#"><span className="fab fa-twitter" /></Link></li>
          <li><Link to="#"><span className="fab fa-twitter" /></Link></li>
          <li><Link to="#"><span className="fab fa-twitter" /></Link></li>
          <li><Link to="#"><span className="fab fa-twitter" /></Link></li>
          <li><Link to="#"><span className="fab fa-twitter" /></Link></li>
        </ul>
      </div>
    </nav>
  </div>

        </div>
    )
}

export default Header;